import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import Badge from 'modules/common/components/Badge';

export const useOpenViewTransaction = () => {
  const createModal = useCreateModal();

  const openViewTransactionModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <ViewTransaction data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openViewTransactionModal;
};

const ViewTransaction = ({ onClose, data }) => (
  <ModalCard size="sm" title="TRANSACTION DETAILS" onClose={onClose}>
    <div className="grid grid-cols-2 px-8 pb-8 mt-3 gap-y-4">
      <div className="font-light">Status</div>
      <Badge
        status={data?.status}
        containerClassName="flex items-center justify-center w-min"
      />
      <div className="font-light">Amount:</div>
      <div className="font-[500] text-gray-700">
        P {+data?.debit ? data?.debit : data?.credit}
      </div>
      <div className="font-light">Organization:</div>
      <div className="font-[500] text-gray-700">
        {data?.organization_name || '--'}
      </div>
      <div className="font-light">Date:</div>
      <div className="font-[500] text-gray-700">{data?.created_at || '--'}</div>
      <div className="font-light">Reference No.:</div>
      <div className="font-[500] text-gray-700">
        {data?.status === 'DRAFT' ? '--' : data?.refno}
      </div>
      <div className="font-light">Date Paid:</div>
      <div className="font-[500] text-gray-700">
        {data?.status === 'DRAFT' ? '--' : data?.updated_at}
      </div>
      <div className="font-light">Remarks:</div>
      <div className="font-[500] text-gray-700 break-words break-after-all">
        {data?.description || '--'}
      </div>
    </div>
  </ModalCard>
);

ViewTransaction.propTypes = {
  onClose: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
};

export default ViewTransaction;
